<template>
  <div>
    <filter-bar ref="filter" mode="range" :scope="scope"
                show-customer
                show-big show-portrait export-code="EEForEduCustomerStats" @change="onFilter"
                @export="toExport" />
    <el-table v-loading="listLoading" :data="list" border size="small">
      <el-table-column label="用户信息" align="center">
        <el-table-column label="下单人姓名" prop="customerName" align="center"
                         min-width="90"
                         fixed />
        <el-table-column label="身份" prop="levelName" align="center" width="80" />
        <el-table-column label="是否大客户" align="center" width="90">
          <template slot-scope="{row}">{{ row.isBig ? '是' : '否' }}</template>
        </el-table-column>
        <el-table-column label="大客户负责老师" prop="bigTeacherName" align="center" width="110" />
        <el-table-column label="省" prop="provinceName" align="center" width="80" />
        <el-table-column label="市" prop="cityName" align="center" width="90" />
        <el-table-column label="技术老师" prop="technicianName" align="center" width="90" />
      </el-table-column>
      <el-table-column label="新版APP普通商城订单" align="center">
        <el-table-column label="订单总数" prop="orderCount" align="center" width="80" />
        <el-table-column label="余额/现金支付" prop="balanceMoney" align="center" width="110" />
        <el-table-column label="零售价支付" prop="xiaoduMoney" align="center" width="100" />
        <el-table-column label="赠送支付" prop="giftMoney" align="center" width="100" />
        <el-table-column label="合计（折算）" prop="totalPerformance" align="center" width="110">
          <template slot="header">
            合计（折算）
            <el-tooltip content="余额/现金×1 + 零售价×0.5 + 赠送×2/3，与下单业绩口径一致" placement="top"><i class="el-icon-question" /></el-tooltip>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="新版APP秒杀订单" align="center">
        <el-table-column label="秒杀数量" prop="seckillCount" align="center" width="80" />
        <el-table-column label="秒杀支付总金额" prop="seckillMoney" align="center" width="120" />
      </el-table-column>
      <!-- REQ-2026-823596 面板 9：画像三列 -->
      <el-table-column label="客户画像与服务" align="center">
        <el-table-column label="是否符合3.0" align="center" width="110">
          <template slot-scope="{row}">
            <el-tag v-if="row.portraitValid" size="mini" type="success">符合·有效</el-tag>
            <span v-else class="muted">-</span>
          </template>
        </el-table-column>
        <el-table-column label="服务周期" align="center" width="90">
          <template slot-scope="{row}">
            <span>{{ serviceCycleText(row.serviceCycle) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="标记次数" prop="portraitMarkCount" align="center" width="90" />
      </el-table-column>

      <!-- 面板 9：最近 3 个自然月服务老师明细。
           ⚠️ 取的是月度快照（customer_service_roster_monthly），不是实时归属 ——
              换了技术老师，历史月份仍显示当时那个人。
           ⚠️ 快照由 scheduler 每月 1 号生成；**只发 api 不发 scheduler 时这一列组全空**，
              且后端不报错。看到整列空白先确认 scheduler 发了没有。 -->
      <el-table-column label="最近3个月服务老师" align="center">
        <el-table-column v-for="i in 3" :key="i" :label="rosterMonthLabel(i - 1)" align="center" width="150">
          <template slot-scope="{row}">
            <div v-if="rosterOf(row, i - 1)" class="roster-cell">
              <div>技术：{{ rosterOf(row, i - 1).technicianName || '-' }}</div>
              <div>大客户：{{ rosterOf(row, i - 1).bigTechName || '-' }}</div>
              <div>督导：{{ rosterOf(row, i - 1).supervisorName || '-' }}</div>
            </div>
            <span v-else class="muted">-</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column label="服务次数" align="center">
        <el-table-column label="是否有服务" align="center" width="90">
          <template slot-scope="{row}">{{ row.hasService ? '是' : '否' }}</template>
        </el-table-column>
        <el-table-column label="新版APP签到次数" prop="signCount" align="center" width="120" />
      </el-table-column>
    </el-table>
    <pagination v-show="total > 0" :total="total" :page-no.sync="query.pageNo"
                :page-size.sync="query.pageSize"
                @pagination="doQueryList" />
  </div>
</template>

<script>
import eduStatsApi from '@/api/count/eduStats'
import Pagination from '@/components/Pagination'
import filterBar from './filterBar.vue'
import { serviceCycleText } from '@/utils/customerPortrait'

/**
 * 客户数据明细（周/月模板的客户 sheet）
 * 默认只列区间内有订单或有签到的客户
 */
export default {
  components: { Pagination, filterBar },
  props: { scope: { type: Object, default: () => ({}) } },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      filter: {},
      query: { pageNo: 1, pageSize: 20 }
    }
  },
  mounted() {
    this.filter = this.$refs.filter.buildQuery()
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    serviceCycleText,
    rosterMonthLabel(index) {
      const date = new Date()
      date.setDate(1)
      date.setMonth(date.getMonth() - index)
      return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0')
    },
    rosterOf(row, index) {
      return (row.recentRosters || []).find(roster => roster.month === this.rosterMonthLabel(index)) || null
    },
    onFilter(q) {
      this.filter = q
      this.doQueryList({ pageNo: 1 })
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) this.query.pageNo = pageNo
      if (pageSize) this.query.pageSize = pageSize
      this.listLoading = true
      eduStatsApi.customerList({ ...this.filter, ...this.query }).then(({ data }) => {
        this.list = (data && data.list) || []
        this.total = (data && data.total) || 0
      }).catch(() => {
        this.list = []
        this.total = 0
      }).finally(() => { this.listLoading = false })
    },
    toExport() {
      this.$router.push('/export/list?code=EEForEduCustomerStats')
    }
  }
}
</script>

<style scoped>
.muted { color: #c0c4cc; }
.roster-cell { font-size: 12px; line-height: 1.5; text-align: left; padding-left: 6px; }
</style>
